import SearchSummaryContainer from './SearchSummaryContainer';

export default SearchSummaryContainer;
